

















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { Logger } from 'aws-amplify';
import StorageImage from "@/components/common/StorageImage.vue";
import Decisions from "@/store/modules/Decisions";
import Users from "@/store/modules/Users";
import Colors from "@/utils/Colors";

const decisionsModule = getModule(Decisions);
const usersModule = getModule(Users);
// Logger.LOG_LEVEL = "DEBUG";
const logger = new Logger("UserAvatar.vue");

@Component({
    components: { StorageImage },
})
export default class UserAvatar extends Vue {

    @Prop({type: Boolean, default: false})
    disabled!: boolean;

    @Prop({type: String, default: ''})
    name!: string;

    @Prop({type: String, default: ''})
    userId!: string;

    @Prop({type: String, default: ''})
    color!: string;

    @Prop({type: String, default: ''})
    size!: string;

    private colors = Colors.COLORS;

    private user: any = {
        first: '',
        last: '',
        phone: '',
        email: '',
        image: '',
    };

    private redraw: number= 0;

    mounted() {
        if (this.userProfiles.hasOwnProperty(this.userId)) {
            this.user = Object.assign(this.user, this.userProfiles[this.userId]);
        }
    }

    get avatarIndex() {
        return Object.keys(this.userProfiles).findIndex(el => el === this.userId);
    }

    get userProfiles() {
        return decisionsModule.selectedDecisionUsers;
    }

    @Watch('userProfiles',{deep: true})
    private userProfileChanged() {
        if (this.userProfiles.hasOwnProperty(this.userId)) {
            this.user = Object.assign(this.user, this.userProfiles[this.userId]);
        }
    }

    @Watch('userId',{deep: true})
    private userIdChanged() {
        if (this.userProfiles.hasOwnProperty(this.userId)) {
            this.user = Object.assign(this.user, this.userProfiles[this.userId]);
        }
        this.redraw++;
    }

    /**
     *
     *  HEIGHTS OF <v-chip> BASED ON this.size
     *
     *  x-small = 16px
     *  small   = 24px
     *  default = 32px
     *  large   = 54px
     *  x-large = 66px
     *
     */

    get height() {
        switch (this.size) {
            case 'x-small':
                return 16;
            case 'small':
                return 24;
            case 'large':
                return 54;
            case 'x-large':
                return 66;
            default:
                return 32;
        }
    }

    get avatarStyles() {
        return {
            'width': this.height - 8 + 'px !important',
            'min-width': this.height - 8 + 'px !important',
            'max-width': this.height - 8 + 'px !important',
            'height': this.height - 8 + 'px !important',
            'min-height': this.height - 8 + 'px !important',
            'max-height': this.height - 8 + 'px !important',
            'font-size': this.height / 2 - 4 + 'px !important',
            'position': 'relative',
            'margin-left': '17px',
        };
    }

}

